import { Button } from '@portal_components/components/Button';
import { FormCard } from '@portal_components/components/FormCard';
import { TableHeadings } from '@portal_components/components/TableHeadings';
import { Contract, ENewOrUpdatePrices, EPageViewType } from '../../types';
import React, { useState } from 'react';
import { FormCheckbox } from '@portal_components/components/FormCheckbox';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { ServiceListItem } from './ServiceListItem';

interface ServicelistProps {
  readonly: boolean;
  viewType?: EPageViewType;
}

export const ServiceList = ({ readonly, viewType }: ServicelistProps) => {
  // in the format "[serviceIndex]-[siteDetailIndex]"
  const [expandedPricingMatrix, setExpandedPricingMatrix] = useState<string | null>(null);
  const { watch } = useFormContext<Contract>();

  const [assetOwnership, contractType, updateOrNewPrices] = watch(['assetOwnership', 'contractType', 'updateOrNewPrices']);

  const { fields, append, remove } = useFieldArray<Contract, 'serviceList'>({ name: 'serviceList' });

  return (
    <div className="flex flex-col w-full">
      {(!assetOwnership || !contractType) && (
        <FormCard title="Services">
          <div className="flex flex-row justify-center pt-2">Please select Asset Ownership and Contract Type to add services</div>
        </FormCard>
      )}
      {!!assetOwnership && !!contractType && (
        <FormCard title="Services">
          {updateOrNewPrices === ENewOrUpdatePrices.NEW && (
            <FormCheckbox<Contract> title="Any changes made to these prices will remove future dated prices" name="removeFutureDatedServicePrices" readonly={readonly} />
          )}
          <TableHeadings headings={['Service Code', 'Service Start Date', 'Service End Date']} />
          {fields.map((_, index) => (
            <ServiceListItem
              key={`ServiceStandardPrice-${index}`}
              index={index}
              readonly={readonly}
              viewType={viewType}
              removeService={remove}
              expandedPricingMatrix={expandedPricingMatrix}
              setExpandedPricingMatrix={setExpandedPricingMatrix}
            />
          ))}
          {!readonly && (
            <div className="flex flex-row justify-end pt-3 pb-2">
              <Button text="Add Service" primary={false} onClick={() => append({})} />
            </div>
          )}
        </FormCard>
      )}
    </div>
  );
};
